import { useEffect } from "react";
import useThemeMediaQuery from "@fuse/hooks/useThemeMediaQuery";
import usePathname from "@fuse/hooks/usePathname";
import useFuseLayoutSettings from "@fuse/core/FuseLayout/useFuseLayoutSettings";
import NavbarToggleFabLayout1 from "./NavbarToggleFabLayout1";
import NavbarStyle1 from "./navbar/style-1/NavbarStyle1";
import { useNavbarContext } from "../../components/navbar/contexts/NavbarContext/useNavbarContext";
import NavbarTheme from "@/contexts/themeContext/NavbarTheme";

/**
 * The navbar wrapper layout 1.
 */
function NavbarWrapperLayout1() {
	const { config } = useFuseLayoutSettings();
	const { closeMobileNavbar, isOpen: isNavbarOpen } = useNavbarContext();

	const pathname = usePathname();

	const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));

	useEffect(() => {
		if (isMobile) closeMobileNavbar();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname, isMobile]);

	return (
		<>
			<NavbarTheme>
				<>{config.navbar.style === "style-1" && <NavbarStyle1 />}</>
			</NavbarTheme>
			{config.navbar.display && !config.toolbar.display && !isNavbarOpen && <NavbarToggleFabLayout1 />}
		</>
	);
}

export default NavbarWrapperLayout1;
